/** User-facing delivery outcome parts for invoice / credit-note toasts. */
export function describeDeliveryOutcome(result) {
  const parts = [];
  const delivery = result?.delivery;
  if (!delivery) return parts;

  const email = delivery.email;
  const whatsapp = delivery.whatsapp;

  if (email?.sent) {
    parts.push(`emailed to ${delivery.recipientEmail || "customer"}`);
  } else if (email?.reason === "no_customer_email") {
    parts.push("email skipped (no customer email)");
  } else if (email?.reason === "no_smtp") {
    parts.push("email failed (SMTP not configured)");
  } else if (email?.reason === "smtp_error") {
    parts.push(`email failed (${email.error || "SMTP error"})`);
  } else if (email?.error) {
    parts.push(`email failed (${email.error})`);
  }

  if (whatsapp?.sent) {
    parts.push("WhatsApp sent");
  } else if (whatsapp?.reason === "invalid_phone") {
    parts.push("WhatsApp skipped (invalid phone)");
  } else if (whatsapp?.reason === "skipped") {
    parts.push("WhatsApp skipped (not configured)");
  } else if (whatsapp?.error) {
    parts.push(`WhatsApp failed (${whatsapp.error})`);
  }

  if (delivery.error) {
    parts.push(delivery.error);
  }

  return parts;
}

export function toastDeliveryOutcome(baseMessage, result) {
  const parts = describeDeliveryOutcome(result);
  if (!parts.length) return { message: baseMessage, type: "success" };

  const message = `${baseMessage} ${parts.join("; ")}.`;
  const hasError = parts.some(
    (p) => p.includes("failed") || p.includes("SMTP not configured")
  );
  const hasWarning = parts.some((p) => p.includes("skipped"));
  const type = hasError ? "error" : hasWarning ? "warning" : "success";
  return { message, type };
}
